import { AlertTriangle, Loader2 } from 'lucide-react';
import { AdminPageHeader, StatCard, useFetcher } from './_P1Common';

export default function AdminChurnPrediction() {
  const { data, loading } = useFetcher('churn-prediction');
  if (loading || !data) return <AdminPageHeader icon={AlertTriangle} title="Predviđanje odlazaka"><Loader2 className="animate-spin"/></AdminPageHeader>;
  return (
    <div data-testid="admin-churn-prediction">
      <AdminPageHeader icon={AlertTriangle} title="Predviđanje odlazaka" subtitle="Pretplatnici koji se nisu prijavili unutar 30 dana"/>
      <div className="px-4 md:px-6 mb-6 grid grid-cols-2 md:grid-cols-3 gap-3">
        <StatCard testid="churn-total" label="Ukupno pretplatnika" value={data.total_subscribers} accent="blue"/>
        <StatCard testid="churn-risk" label="U riziku" value={data.total} accent="amber"/>
      </div>
      <div className="px-4 md:px-6 pb-6 overflow-x-auto rounded-lg border border-zinc-800 mx-4 md:mx-6">
        <table className="min-w-full text-sm">
          <thead className="bg-zinc-900 text-xs text-zinc-400 uppercase">
            <tr>
              <th className="px-4 py-2 text-left">Email</th>
              <th className="px-4 py-2 text-left">Ime</th>
              <th className="px-4 py-2 text-left">Posljednja prijava</th>
              <th className="px-4 py-2 text-left">Rizik</th>
            </tr>
          </thead>
          <tbody>
            {(data.items || []).map(u => (
              <tr key={u.id} className="border-t border-zinc-800">
                <td className="px-4 py-2 break-all">{u.email}</td>
                <td className="px-4 py-2">{u.name || '—'}</td>
                <td className="px-4 py-2 text-xs text-zinc-500">{(u.last_login_at || '').slice(0, 10)}</td>
                <td className="px-4 py-2">
                  <span className={`text-xs px-2 py-0.5 rounded ${u.risk === 'high' ? 'bg-red-900/50 text-red-200' : 'bg-amber-900/50 text-amber-200'}`}>
                    {u.risk === 'high' ? 'Visok' : 'Srednji'}
                  </span>
                </td>
              </tr>
            ))}
            {(data.items || []).length === 0 && (
              <tr><td colSpan={4} className="px-4 py-8 text-center text-zinc-500">Nema rizičnih korisnika.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
